import { OPEN_DIALOG_EVENT } from 'components/Dialog/Root';

import { dispatch } from 'lib/eventManager';

const showDialog = (component, props = {}) => {
  dispatch(OPEN_DIALOG_EVENT, { component, props });
};

const useDialog = () => {
  return { showDialog };
};

export default useDialog;
